import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getCustomerList = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.customers
);

export const getCustomerListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.customersLoading
);

export const getCustomerListError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.customersError
);

export const getCustomer = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.customer
);

export const getCustomerLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.customerLoading
);

export const getCustomerError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.customerError
);

export const createCustomerSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerSuccess
);

export const createCustomerLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerLoading
);

export const createCustomerError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerError
);

export const createCustomerCompanySuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerCompanySuccess
);

export const createCustomerCompanyLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerCompanyLoading
);

export const createCustomerCompanyError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerCompanyError
);

export const getCreatedCustomerCompany = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createdCustomerCompany
);

export const createCustomerAddressSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerAddressSuccess
);

export const createCustomerAddressLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerAddressLoading
);

export const createCustomerAddressError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createCustomerAddressError
);

export const getCreatedCustomerAddress = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.createdCustomerAddress
);

export const updateCustomerSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerSuccess
);

export const updateCustomerLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerLoading
);

export const updateCustomerError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerError
);

export const updateCustomerCompanySuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerCompanySuccess
);

export const updateCustomerCompanyLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerCompanyLoading
);

export const updateCustomerCompanyError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerCompanyError
);

export const updateCustomerAddressSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerAddressSuccess
);

export const updateCustomerAddressLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerAddressLoading
);

export const updateCustomerAddressError = createSelector(
  getKwikspaceAppState,
  (state) => state.customer.updateCustomerAddressError
);
